{
  "title": "Banishment",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level abjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (an item distasteful to the target)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You attempt to send one creature that you can see within range to another place of existence. The target must succeed on a Charisma saving throw or be banished.",
    "If the target is native to the plane of existence you’re on, you banish the target to a harmless demiplane. While there, the target is incapacitated. The target remains there until the spell ends, at which point the target reappears in the space it left or in the nearest unoccupied space if that space is occupied.",
    "If the target is native to a different plane of existence that the one you’re on, the target is banished with a faint popping noise, returning to its home plane. If the spell ends before 1 minute has passed, the target reappears in the space it left or in the nearest unoccupied space if that space is occupied. Otherwise, the target doesn’t return.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, you can target one additional creature for each slot level above 4th."
  ],
  "spellLists": ["cleric", "eldritch-knight", "paladin", "sorcerer", "warlock", "wizard"]
}
